export class Variables {
    public static STORAGE_AUTH = 'STORAGE_AUTH';
    public static USER_AUTH = 'USER_AUTH';
    public static USER_LOGIN = 'USER_LOGIN';
    public static CLASS_STORAGE = 'CLASS_STORAGE';
    public static METTING_STORAGE = 'METTING_STORAGE';
    public static SHOW_HELP_ACCESS_CLASS = 'SHOW_HELP_ACCESS_CLASS';
    public static SHOW_CAMERA_MESSAGE = 'SHOW_CAMERA_MESSAGE';
    public static IP_USER = 'IP_USER';
    public static PRODUCTS = 'PRODUCTS';
    public static FINANCIAL_CANDIDATE_SITUATION = 'FINANCIAL_CANDIDATE_SITUATION';
    public static SHOW_MARK_MESSAGE = 'SHOW_MARK_MESSAGE';
    public static PERMISSIONS = 'PERMISSIONS';
    public static ROLES = 'ROLES';
    public static MENU = 'MENU';
    public static CHECK_SOM = 'CHECK_SOM';
    public static MOCK_MONITORAMENTO = 'MOCK_MONITORAMENTO';
    public static CLASS_STATE = 'CLASS_STATE';
    public static USER_DATA = "res"
    public static ECV_LIST = "ECV_LIST";
    public static SUPORT_CONTACT = "SUPORT_CONTACT";
    public static USER_LIST = "USER_LIST";
    public static VEHICLES_TYPE_LIST = "VEHICLES_TYPE_LIST";
    public static USERS_PROFILES = "USERS_PROFILES";
    public static CLIENTE_FORNECEDOR = "CLIENTE_FORNECEDOR";
    public static STATUS_INSPECTION_LIST = "STATUS_INSPECTION_LIST";
    public static CHASSI_SITUATION_LIST = "CHASSI_SITUATION_LIST";
    public static VALIDATE_HOURS = "VALIDATE_HOURS";
    public static STATE = "BR_STATES";
    public static TYPE_PROFILES_LIST = "TYPE_PROFILES_LIST";
    public static DOCUMENTS_TYPES_LIST = "DOCUMENTS_TYPES_LIST";
    public static FILIAL_GROUP = "FILIAL_GROUP";

  }
  